import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useEventStore = defineStore('event', {
    state: () => {
        return {
            all: null
        }
    },
    actions: {
        sortAll() {
            this.all = this.all.sort((a, b) => {
                const orderedEvents = new Date(a.start_date) - new Date(b.start_date)

                if (orderedEvents === 0) {
                    return new Date(a.end_date) - new Date(b.end_date)
                }

                return orderedEvents
            })
        },
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.EVENT.INDEX)

                this.all = data
                this.sortAll()
            } catch { /**/ }
        },
        setFilterDate(date) {
            this.filterDate = date ? date.date : null
        },
        async uploadImage(id, image) {
            try {
                const formData = new FormData()
                formData.append('image', image)

                const {data} = await http.post(API_ENDPOINTS.EVENT.UPLOAD_IMAGE.replace(':id', id), formData)

                this.all = this.all.map(event => {
                    if (event.id.toString() === id.toString()) {
                        event.image = data.data
                    }

                    return event
                })
            } catch { /**/ }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.EVENT.DESTROY.replace(':id', id))

                this.all = this.all.filter(event => event.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.EVENT.STORE, payload)

                this.all.push(data)
                this.sortAll()

                return data.id
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.EVENT.UPDATE.replace(':id', id), payload)

                this.all = this.all.map(event => {
                    if (event.id.toString() === id.toString()) {
                        event = data
                    }

                    return event
                })
                
                return data.id
            } catch { /**/ }
        }
    }
})